import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const FarmIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest} fill="none">
      <path
        d="M3 9.99999C2.99993 9.70906 3.06333 9.42161 3.18579 9.15771C3.30824 8.8938 3.4868 8.65979 3.709 8.47199L10.709 2.47199C11.07 2.1669 11.5274 1.99951 12 1.99951C12.4726 1.99951 12.93 2.1669 13.291 2.47199L20.291 8.47199C20.5132 8.65979 20.6918 8.8938 20.8142 9.15771C20.9367 9.42161 21.0001 9.70906 21 9.99999V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V9.99999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15 20.0103V13.3121C15 13.0901 14.8946 12.8771 14.7071 12.7201C14.5196 12.5631 14.2652 12.4749 14 12.4749H10C9.73478 12.4749 9.48043 12.5631 9.29289 12.7201C9.10536 12.8771 9 13.0901 9 13.3121V20.0103"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M8.71082 13.4332L15.2892 20.0102" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12.0001" cy="8.0318" r="1.5193" stroke="currentColor" strokeWidth="1.4" />
    </SvgIcon>
  )
}
export default FarmIcon
